<template>
    <div class="arch-row" :class="row.type === 'primary' ? 'primary-row' : ''">
        <div class="quadrant-half justify-content-end">
            <span class="quadrant-label">{{ row.leftLabel }}</span>
            <button
                v-for="tooth in row.left" :key="tooth.value"
                class="btn tooth-btn"
                :class="getToothClass(tooth.code, row.type)"
                @click="onSelect(tooth.code)"
            >
                <span class="tooth-code">{{ tooth.code }}</span>
            </button>
        </div>
        <div class="arch-divider"></div>
        <div class="quadrant-half">
            <button
                v-for="tooth in row.right" :key="tooth.value"
                class="btn tooth-btn"
                :class="getToothClass(tooth.code, row.type)"
                @click="onSelect(tooth.code)"
            >
                <span class="tooth-code">{{ tooth.code }}</span>
            </button>
            <span class="quadrant-label">{{ row.rightLabel }}</span>
        </div>
    </div>
</template>

<script setup>
const props = defineProps({
    row: {
        type: Object,
        required: true
    },
    getToothClass: {
        type: Function,
        required: true
    },
});

const emit = defineEmits(['select']);

const onSelect = (value) => {
    emit('select', value);
}
</script>

<style scoped>
.arch-row {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 8px;
}
.quadrant-label {
    flex: 0 0 26px;
    text-align: center;
    font-size: 0.7rem;
    font-weight: 700;
    color: #2d4ea2;
}
.quadrant-half {
    display: flex;
    flex: 1;
    align-items: center;
    gap: 4px;
}
.quadrant-half.justify-content-end {
    justify-content: flex-end;
}
.arch-divider {
    width: 2px;
    background: #cfd6e4;
    margin: 0 8px;
}
.tooth-btn {
    flex: 0 0 calc((100% - 58px) / 8);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 6px 2px;
    min-width: 0;
    font-weight: 700;
    border-radius: 6px;
}
.tooth-code {
    font-size: 0.95rem;
    line-height: 1.1;
}
</style>
